import { useTradePanelTab } from "#/store/app/tradePanel/tradePanelTab";
import { useOptionTradeType } from "#/store/options/tradePanel/optionTradeType";
import { usePerpTradeType } from "#/store/perps/tradePanel/perpTradeType";

export const useTradeType = () => {
  const { isOptions } = useTradePanelTab();
  const {
    isMarket: oIsMarket,
    isLimit: oIsLimit,
    isRFQ: oIsRFQ,
  } = useOptionTradeType();
  const {
    isMarket: pIsMarket,
    isLimit: pIsLimit,
    isRFQ: pIsRFQ,
  } = usePerpTradeType();

  const isMarket = isOptions ? oIsMarket : pIsMarket;
  const isLimit = isOptions ? oIsLimit : pIsLimit;
  const isRFQ = isOptions ? oIsRFQ : pIsRFQ;

  return { isMarket, isLimit, isRFQ };
};
